module.exports = __webpack_public_path__ + "img/ad01.559b58af.png";